import "../../styles/remediation_dashbard.css";
import "../../styles/remediationDashboardKpis.css";
import "../../styles/remediationDashboardVisual.css";

import { hasRemediationAccess } from "../../config/searchSpaces";

import RemediationVisualOverview from "./components/RemediationVisualOverview";
import AiInsightsPanel from "./components/AiInsightsPanel";
import KeyPerformanceMetrics from "./components/KeyPerformanceMetrics";
import IssueBreakdownCards from "./components/IssueBreakdownCards";

import CaseTrendByStatus from "./components/CaseTrendByStatus";
import CaseTrendByStep from "./components/CaseTrendByStep";
import CaseTypesByStatus from "./components/CaseTypesByStatus";

import ClosureDurationTrend from "./components/ClosureDurationTrend";
import FeedbackTrend from "./components/FeedbackTrend";
import CaseTrendByRemediationType from "./components/CaseTrendByRemediationType";
import CaseTrendByManagedBy from "./components/CaseTrendByManagedBy";

export default function RemediationDashboard({ searchSpace }) {
  return (
    <div className="remediation-dashboard-shell">
      <main className="remediation-dashboard-main">
        <div className="remediation-dashboard-inner">
          <header className="remediation-dashboard-header-row remediation-dashboard-header-row--with-subtitle">
            <div>
              <h2 className="remediation-dashboard-title">
                Analytics Dashboard - Overview
              </h2>
              <p className="remediation-dashboard-page-subtitle">
                The remediation solving process at a glance
              </p>
            </div>
          </header>

          <section className="remediation-dashboard-section-surface">
            {!hasRemediationAccess(searchSpace) ? (
              <div className="remediation-dashboard-empty-state">
                Analysis data is currently only implemented for the IN search space.
              </div>
            ) : (
              <div className="remediation-dashboard-stack">
                <RemediationVisualOverview />

                <AiInsightsPanel />

                <KeyPerformanceMetrics />

                <IssueBreakdownCards />

                <div className="remediation-dashboard-detail-divider">
                  Detailed Analysis
                </div>

                <div className="remediation-dashboard-row">
                  <CaseTrendByStatus />
                  <CaseTrendByStep />
                </div>

                <div className="remediation-dashboard-row">
                  <ClosureDurationTrend />
                  <FeedbackTrend />
                </div>

                <CaseTrendByRemediationType />

                <CaseTrendByManagedBy />

                <CaseTypesByStatus />
              </div>
            )}
          </section>
        </div>
      </main>
    </div>
  );
}